<template>
  <div>
    <div v-if="loadingPage" class="loading-overlay">
      <b-spinner
        label="Loading..."
        variant="primary"
        class="spinner"
      ></b-spinner>
    </div>
    <div v-else>
      <div class="header">
        <h1>Venture West Team</h1>
        <div class="d-flex" style="gap: 10px">
          <button class="button" @click="modals.newMember = true">
            New Member <img src="/static/img/plus-white.svg" alt="" />
          </button>
          <div
            style="position: relative"
            v-click-outside="() => (isShowMembers = false)"
          >
            <button
              class="button between"
              @click="isShowMembers = !isShowMembers"
            >
              <img
                style="height: 15px"
                src="/static/img/person.svg"
                alt=""
              /><span>People</span>
            </button>
            <div v-if="isShowMembers" class="dropdown-container">
              <table class="dropdown-table">
                <tr
                  v-for="(member, index) in tasks"
                  @click="scrollTo(member.userId)"
                  :key="index"
                >
                  <td>
                    <img
                      style="height: 30px"
                      :src="getProcessedImageUrl(member?.imageURL)"
                    />
                  </td>
                  <td>{{ member?.name }}</td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div
        v-for="task in tasks"
        :key="task.name"
        style="margin-top: 50px"
        :id="`task-${task.userId}`"
      >
        <div
          :class="['d-flex', 'expandable', { expanded: task.isExpanded }]"
          :style="{ color: task.backgroundColor }"
        >
          <svg
            @click="task.isExpanded = !task.isExpanded"
            class="chevron"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="currentColor"
            style="margin-top: 7px; cursor: pointer"
          >
            <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z" />
          </svg>
          <b
            @click="task.isExpanded = !task.isExpanded"
            style="font-size: 25px; margin-left: 10px; cursor: pointer"
            >{{ task.name }}</b
          >
          <div class="flex-grow-1 flex"></div>
          <div
            @click="addingNewTask(task)"
            style="color: #404040bf; padding-top: 8px; cursor: pointer"
          >
            <img src="/static/img/plus.svg" alt="" /> Add Task
          </div>
        </div>
        <div :class="[{ expanded: task.isExpanded }, 'accordionBody']">
          <table class="countiesTask">
            <thead>
              <tr :style="{ 'background-color': task.backgroundColor }">
                <th>Task</th>
                <th>Assigned By</th>
                <th>Date Assigned</th>
                <th>Date Complete</th>
                <th>Time</th>
                <th>Status</th>
                <th>Notes</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(taskItem, index) in task.tasks" :key="index">
                <td>
                  {{ taskItem.name }}
                </td>
                <td>{{ taskItem.assignedBy }}</td>
                <td>{{ taskItem.dateAssigned }}</td>
                <td>{{ $global.formatDate(taskItem.dueDate) }}</td>
                <td>
                  <div>
                    <div>
                      <svg
                        v-show="!taskItem.isRunning"
                        @click="taskItem.isRunning = true"
                        style="cursor: pointer"
                        width="12"
                        height="12"
                        viewBox="0 0 12 12"
                        fill="#3C78FF"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12 6.85714H6.85714V12H5.14286V6.85714H0V5.14286H5.14286V0H6.85714V5.14286H12V6.85714Z"
                        />
                      </svg>
                    </div>
                    <p>50 min 0 secs</p>
                    <div>
                      <img
                        v-show="taskItem.isRunning"
                        @click="taskItem.isRunning = false"
                        src="/static/img/stop-sign.svg"
                        alt=""
                      />
                    </div>
                  </div>
                </td>
                <td :style="{ color: setTextColor(taskItem.status) }">
                  {{ taskItem.status }}
                </td>
                <td>
                  <img
                    @click="
                      modals.setNote = true;
                      selectedNote = taskItem.notes;
                    "
                    src="/static/img/notes.svg"
                    style="cursor: pointer"
                    alt=""
                  />
                </td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td>Total</td>
                <td>+ 5 hrs 50 min 0 sec</td>
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <Modal :title="'New Member'" v-model="modals.newMember">
        <div class="modalBody">
          <div class="row">
            <div :class="['formLabel', 'col-3']">Select Member</div>
            <div class="col-9">
              <hilo-select
                ref="newMember"
                v-model="newMemberForm.member"
                :multiple="false"
                :searchable="true"
                :options="[]"
                :placeholder="'Choose One'"
                :theme="'grey'"
              />
            </div>
          </div>
          <div class="row">
            <div :class="['formLabel', 'col-3']">Who Can Assign</div>
            <div class="col-9">
              <hilo-select
                ref="newMember"
                v-model="newMemberForm.whoCanAssign"
                :multiple="true"
                :searchable="true"
                :options="[]"
                :placeholder="'Select All that Apply'"
                :theme="'grey'"
              />
            </div>
          </div>
          <div>
            <div v-for="(task, index) in newMemberForm.tasks" :key="task.id">
              <p style="font-size: 18px">Task {{ index + 1 }}</p>
              <input
                v-model="task.name"
                style="margin-top: -5px"
                placeholder="Type task here..."
              />
              <div class="d-flex" style="gap: 10px; margin-top: 10px">
                <div class="flex-grow-1">
                  <el-date-picker
                    v-model="task.date"
                    type="date"
                    placeholder="Date picker here"
                  >
                  </el-date-picker>
                </div>
                <div class="flex-grow-1">
                  <hilo-select
                    ref="status"
                    v-model="task.status"
                    :multiple="false"
                    :searchable="true"
                    :options="[]"
                    :placeholder="'Status'"
                    :theme="'grey'"
                  />
                </div>
              </div>
            </div>

            <div
              style="width: 100%; margin-top: 10px"
              class="d-flex justify-content-end"
            >
              <div
                @click="addTaskUI()"
                style="
                  font-size: 18px;
                  color: rgba(64, 64, 64, 0.75);
                  cursor: pointer;
                "
              >
                <img src="/static/img/plus.svg" alt="" /> Add Task
              </div>
            </div>
          </div>
        </div>

        <template #footer>
          <div class="d-flex" style="gap: 10px; width: 100%">
            <button @click="modals.newMember = false" style="width: 100%">
              Save
            </button>
          </div>
        </template>
      </Modal>

      <Modal :title="newTaskForm.owner" v-model="modals.newTask">
        <div class="modalBody">
          <div v-for="(task, index) in newTaskForm.tasks" :key="task.id">
            <p style="font-size: 18px">Task {{ index + 1 }}</p>
            <input
              v-model="task.name"
              style="margin-top: -5px"
              placeholder="Type task here..."
            />
            <div class="d-flex" style="gap: 10px; margin-top: 10px">
              <div class="flex-grow-1">
                <el-date-picker
                  v-model="task.date"
                  type="date"
                  placeholder="Date picker here"
                >
                </el-date-picker>
              </div>
              <div class="flex-grow-1">
                <hilo-select
                  ref="status"
                  v-model="task.status"
                  :multiple="false"
                  :searchable="true"
                  :options="taskStatuses"
                  :placeholder="'Status'"
                  :theme="'grey'"
                />
              </div>
            </div>
          </div>
          <div
            style="width: 100%; margin-top: 10px"
            class="d-flex justify-content-end"
          >
            <div
              @click="addTaskUI('taskForm')"
              style="
                font-size: 18px;
                color: rgba(64, 64, 64, 0.75);
                cursor: pointer;
              "
            >
              <img src="/static/img/plus.svg" alt="" /> Add Task
            </div>
          </div>
        </div>
        <template #footer>
          <div class="d-flex" style="gap: 10px; width: 100%">
            <button @click="addTask()" style="width: 100%">Save</button>
          </div>
        </template>
      </Modal>
      <Modal title="Notes" v-model="modals.setNote">
        <div style="width: 100%">
          <div v-for="(note, index) in selectedNote" :key="index">
            <div>
              <div>
                <b>{{ note?.noteSubject }}</b>
              </div>
              <div>
                <span style="color: #40404050; font-size: 14px">Feb 21</span>
              </div>
              <div>{{ note.note }}</div>
            </div>
            <hr />
          </div>
        </div>
        <div style="width: 100%">
          <div class="row">
            <div :class="['formLabel', 'col-3']">Subject</div>
            <div class="col-9">
              <input
                v-model="noteForm.subject"
                class="name"
                placeholder="Subject..."
              />
            </div>
          </div>
          <div class="row" style="margin-top: 15px">
            <div :class="['formLabel', 'col-3']">Cc</div>
            <div class="col-9">
              <hilo-select
                ref="notes"
                v-model="noteForm.cc"
                :searchable="true"
                :options="[]"
                :placeholder="'Select all that apply'"
                :theme="'grey'"
              />
            </div>
          </div>
          <div class="row" style="margin-top: 15px">
            <div :class="['formLabel', 'col-3']">Note</div>
            <div class="col-9">
              <input
                v-model="noteForm.note"
                class="name"
                placeholder="Write note..."
              />
            </div>
          </div>
        </div>
        <template #footer>
          <button @click="modals.setNote = false" style="width: 100%">
            Save
          </button>
        </template>
      </Modal>
    </div>
    <el-dialog center title="Error" :visible.sync="modals.error">
      <div class="text-center">
        <span>Error: {{ error_txt }}</span>
        <br />
        <span slot="footer" class="dialog-footer">
          <l-button type="btn btn-danger" round @click="closeModal('error')"
            >0K</l-button
          >
        </span>
      </div>
    </el-dialog>
    <el-dialog center title="Success" :visible.sync="modals.success">
      <div class="text-center">
        <span>{{ success_txt }}</span>
        <div class="text-center mt-4">
          <span slot="footer" class="dialog-footer">
            <l-button
              type="btn btn-success"
              round
              @click="closeModal('success')"
              >0K</l-button
            >
          </span>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import TasksAPIService from "src/servicehandlers/TasksAPIService.js";
import UsersAPIService from "../../../servicehandlers/UsersAPIService";
import { DatePicker } from "element-ui";
const tasksAPIService = new TasksAPIService();
const usersAPIService = new UsersAPIService();
import Modal from "../Components/Modal.vue";
import HiloSelect from "@/components/HiloComponents/HiloSelect.vue";
import { Dialog } from "element-ui";
import { getProcessedImageUrl } from "@/util/images";

export default {
  components: {
    [Dialog.name]: Dialog,
    [DatePicker.name]: DatePicker,
    Modal,
    HiloSelect,
  },
  data() {
    return {
      tasks: [],

      modals: {
        success: false,
        error: false,
        newMember: false,
        newTask: false,
        setNote: false,
      },
      showTaskForm: false,
      newMemberForm: {
        member: null,
        whoCanAssign: null,
        tasks: [
          {
            id: 1,
            name: null,
            date: null,
            status: null,
          },
          {
            id: 2,
            name: null,
            date: null,
            status: null,
          },
        ],
      },
      newTaskForm: {
        owner: "",
        ownerId: null,
        tasks: [
          {
            id: 0,
            name: null,
            date: null,
            status: 1,
          },
        ],
      },
      success_txt: "",
      error_txt: "",
      newTask: {
        title: "",
        owner: "",
        status: "pending",
        dueDate: "",
        notes: "",
        ownerId: null,
      },
      noteForm: {
        subject: null,
        cc: null,
        note: null,
      },
      allTasksSelected: false,
      selectedTaskIndex: null, // Index of the task with expanded notes
      selectedNote: null,
      loadingPage: true,
      isShowMembers: false,
      taskStatuses: [
        {
          id: 1,
          name: "Assigned",
        },
      ],
    };
  },
  async mounted() {
    await this.getTasks();
  },

  methods: {
    getProcessedImageUrl,
    toggleTaskForm() {
      this.showTaskForm = !this.showTaskForm;
    },
    async addTask() {
      // Add newTask to tasks array
      //this.tasks.push({ ...this.newTask });

      let successCount = 0; // Track the number of successful task creations

      const promises = this.newTaskForm.tasks.map(async (task) => {
        if (!task.name) {
          return;
        }

        // Validate the task fields before creating
        if (!task.date || !task.status) {
          this.error_txt = "Please fill in all fields for each task.";
          this.handleError();
          return;
        }

        const newTask = {
          name: task.name,
          owner: this.newTaskForm.owner,
          status: task.status,
          dueDate: task.date,
          notes: "",
          ownerId: this.newTaskForm.ownerId,
        };

        tasksAPIService.create(newTask, this.$router);
        successCount++;
      });

      try {
        await Promise.all(promises);

        if (successCount > 0) {
          this.success_txt = `${successCount} of ${promises.length} task(s) created successfully.`;
          this.handleSuccess();

          this.modals.newTask = false; // Close the modal after success
          this.newTaskForm.tasks = [
            {
              id: 0,
              name: null,
              date: null,
              status: 1,
            },
          ]; // Reset the form
          this.getTasks(false); // Refresh the tasks to reflect the newly created ones
        } else {
          this.error_txt = "No tasks were created.";
          this.handleError();
        }
      } catch (error) {
        this.error_txt = "Failed to create tasks: " + error;
        this.handleError();
      }
    },

    addingNewTask(row) {
      this.newTaskForm.owner = row?.name || "";
      this.newTaskForm.ownerId = row?.userId || null; // Set the ownerId for the new task

      this.modals.newTask = true; // Open the new task modal
    },

    getStatusClass(status) {
      return `status-${status}`;
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
    },
    toggleNotes(index) {
      // Close any previously opened notes section.
      if (this.selectedTaskIndex !== null && this.selectedTaskIndex !== index) {
        this.tasks[this.selectedTaskIndex].showNotes = false;
      }
      this.tasks[index].showNotes = !this.tasks[index].showNotes;
      this.selectedTaskIndex = this.tasks[index].showNotes ? index : null;
    },
    selectAllTasks() {
      this.tasks.forEach((task) => (task.checked = this.allTasksSelected));
    },
    updateAllTasksSelected() {
      this.allTasksSelected = this.tasks.every((task) => task.checked);
    },
    openModal(name) {
      this.modals[name] = true;
    },
    closeModal(name) {
      this.modals[name] = false;
    },
    handleError() {
      const self = this;
      this.openModal("error");
      this.spinning = false;
      setTimeout(function () {
        self.modals["error"] = false;
      }, 1500);
    },
    handleSuccess() {
      const self = this;
      this.openModal("success");
      this.spinning = false;
      setTimeout(function () {
        self.modals["success"] = false;
      }, 1500);
    },
    async getTasks(withLoading = true) {
      try {
        if (withLoading) this.loadingPage = true;
        const unfilteredTasks = await tasksAPIService.list(this.$router);

        const tasks = unfilteredTasks.filter((task) => task.name);

        const tempStatuses = await tasksAPIService
          .taskStatusList(this.$router)
          .catch((e) => null); // Load task statuses for the select dropdowns in forms

        // create tasks works
        // load status no works

        const rawData = [];

        const promises = tasks.map(async (task) => {
          const details = await tasksAPIService.getTaskDetailsById(
            task.id,
            this.$router,
          );
          rawData.push(details);
        });
        await Promise.all(promises);

        // declare an empty map
        const map = new Map();

        for (const item of rawData) {
          for (const owner of item.owners) {
            if (map.has(owner.userId)) {
              map.get(owner.userId).tasks.push({
                ...item.task,
                notes: item.notes,
              });
            } else {
              map.set(owner.userId, {
                owner: owner.firstName + " " + owner.lastName,
                userId: owner.userId, // Store the userId for reference
                tasks: [
                  {
                    ...item.task,
                    notes: item.notes,
                    isRunning: false,
                  },
                ],
              });
            }
          }
        }

        this.tasks = Array.from(map, ([key, value]) => ({
          name: value.owner,
          userId: value.userId,
          isExpanded: true,
          isLoadingTasks: false,
          backgroundColor: "#FF6A00",
          tasks: value.tasks,
        }));

        await this.getUsers();
        await this.getProfileOfMembers();
      } catch (error) {
        this.error_txt = "Failed to get tasks: " + error;
        this.handleError();
      } finally {
        this.loadingPage = false;
      }
    },

    async getUsers() {
      const userIdMap = new Map();
      for (const task of this.tasks) {
        for (const taskItem of task.tasks) {
          if (!taskItem.assigned) continue;

          if (userIdMap.has(taskItem.assigned)) {
            const storedUser = userIdMap.get(taskItem.assigned);
            taskItem.assignedBy =
              storedUser.firstName + " " + storedUser.lastName;
          } else {
            const user = await usersAPIService.getById(taskItem.assigned);
            userIdMap.set(taskItem.assigned, user);
            taskItem.assignedBy = user.firstName + " " + user.lastName;
          }
        }
      }
    },

    async getProfileOfMembers() {
      // it must be already ensured that the member owners at this point is unique or finally grouped.

      for (const task of this.tasks) {
        if (!task.userId) continue;
        const user = await usersAPIService.getById(task.userId);

        task.imageURL = user.image;
      }
    },

    addTaskUI(taskType = "memberForm") {
      if (taskType === "memberForm")
        this.newMemberForm.tasks.push({
          id: this.newMemberForm.tasks.length + 1,
          name: null,
          date: null,
          status: null,
        });
      else if (taskType === "taskForm")
        this.newTaskForm.tasks.push({
          id: this.newTaskForm.tasks.length + 1,
          name: null,
          date: null,
          status: null,
        });
    },

    scrollTo(userId) {
      // Scroll to the task section for the given userId
      const element = document.getElementById(`task-${userId}`);
      if (element)
        element.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });

      this.isShowMembers = false;
    },

    setTextColor(text) {
      if (!text) {
        return "#404040"; // Default color if no text is provided
      }

      text = text.toLowerCase(); // Normalize the input to lowercase
      const textcolor = {
        working: "orange",
        complete: "green",
        stuck: "red",
        assigned: "#404040",
      };

      return textcolor[text] ? textcolor[text] : "#404040"; // Fallback to default color if no match found
    },
  },

  directives: {
    clickOutside: {
      bind(el, binding) {
        el.clickOutsideEvent = (event) => {
          if (!(el === event.target || el.contains(event.target))) {
            binding.value();
          }
        };
        document.addEventListener("click", el.clickOutsideEvent);
      },
      unbind(el) {
        document.removeEventListener("click", el.clickOutsideEvent);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  margin-bottom: 20px;

  color: #404040;

  h1 {
    font-weight: bold;
  }
}

.button {
  font-weight: normal;
  height: 25px;
  padding-top: 0;
  line-height: 25px !important;
  border-radius: 5px;

  &.between {
    padding-top: 10px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    min-width: 100px; /* Set an appropriate width */
    padding-left: 5px;
    padding-right: 5px;
  }
}

.countiesTask {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  margin-top: 20px;
  margin-bottom: 20px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);

  th {
    color: #ffffff;
    text-align: center;
    font-weight: normal;
    font-size: 15px;
    padding: 10px;
  }
  th:first-child {
    border-top-left-radius: 10px;
  }
  th:last-child {
    border-top-right-radius: 10px;
  }
  td {
    text-align: center;
    border: 1px solid rgba(64, 64, 64, 0.5);
    border-style: none solid solid none;
    padding-top: 0px !important;
    padding-bottom: 0px !important; /* Override padding for td to align with th */
  }
  tr {
    td {
      font-size: 15px;
    }
    td:first-child {
      padding-left: 10px;
      padding-right: 10px;
      max-width: 180px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  tr:first-child td {
    border-top-style: solid;
  }
  tr td:first-child {
    border-left-style: solid;
  }
  tr:last-child td:first-child {
    border-bottom-left-radius: 10px;
  }

  tr:last-child td:last-child {
    border-bottom-right-radius: 10px;
  }

  th:nth-child(1),
  td:nth-child(1) {
    width: 15%; /* Adjust the width as needed */
  }
  th:nth-child(2),
  td:nth-child(2) {
    width: 15%; /* Adjust the width as needed */
  }
  th:nth-child(3),
  td:nth-child(3) {
    width: 15%; /* Adjust the width as needed */
  }
  th:nth-child(4),
  td:nth-child(4) {
    width: 15%; /* Adjust the width as needed */
  }
  th:nth-child(5),
  td:nth-child(5) {
    width: 15%; /* Adjust the width as needed */
  }

  td:nth-child(5) {
    padding-left: 5px;
    padding-right: 5px;
    div {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 5px;

      p {
        margin: 0;
        font-size: 15px;
      }

      img {
        cursor: pointer;
      }
    }
  }

  th:nth-child(6),
  td:nth-child(6) {
    width: 15%; /* Adjust the width as needed */
  }
  th:nth-child(7),
  td:nth-child(7) {
    width: 10%; /* Adjust the width as needed */
  }
}

.expandable {
  .chevron {
    transform: rotate(180deg);
    transition: transform 0.3s ease;
  }

  &.expanded {
    .chevron {
      transform: rotate(0deg);
    }
  }
}

.accordionBody {
  max-height: 0;
  transition: max-height 0.3s cubic-bezier(0, 1, 0, 1);
  overflow: hidden;

  &.expanded {
    max-height: 1000px;
    transition: max-height 0.3s cubic-bezier(0.4, 0, 1, 1);
  }
}

.formLabel {
  margin-top: 10px;
  position: relative;
  font-size: 18px;
  font-family: Helvetica, Arial, sans-serif;
  color: #404040;
  text-align: left;
  display: inline-block;
}

.modalBody {
  width: 100%;
  > div:not(:first-child) {
    margin-top: 10px;
  }
}

.dropdown-table {
  width: 100%;
  border-collapse: collapse;

  tr {
    cursor: pointer;
    &:hover {
      background-color: #f2f2f2;
    }
  }

  td {
    border: 1px solid #ddd;
    padding-top: 0px !important;
    padding-bottom: 0px !important; /* Override padding for td to align with th */
    text-align: left;
    font-size: 14px;
    color: #404040;
    height: 27px;
    max-height: 27px;
    &:first-child {
      max-width: 20px; /* Adjust as needed */
      padding: 5px 7.5px;
    }
    img {
      height: 30px;
      width: 30px;
      padding: 0 !important; /* Remove padding to ensure the image fits within the circle */
      object-fit: cover; /* Ensure the image fits within the circle */
    }
  }
}

.dropdown-container {
  position: absolute;
  top: 100%; /* Position right below the button */
  right: 0;
  z-index: 1000; /* Ensure it appears above other content */
  background-color: white;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  border-radius: 5px;
  min-width: 200px; /* Set appropriate width */
  margin-top: 5px;
}
</style>
